export const RTE_TOOLBAR_MARKS = {
  bold: 'bold',
  italic: 'italic',
  strikethrough: 'strikethrough',
  underline: 'underline',
  monospace: 'monospace',
  code: 'code',
};
